import React, { createContext, memo, useMemo } from 'react'
import { List, Map } from 'immutable'

export const GridContext = createContext()
export const StripRepeatContext = createContext()

const RepeatCtxComponent = ({ index, isRepeat, isRepeatCol, children, repeatUID, childrenCount }) => {
  const ctx = useMemo(
    () => ({
      index,
      isRepeat,
      isRepeatCol,
      repeatUID,
      childrenCount,
    }),
    [index, isRepeat, isRepeatCol, repeatUID, childrenCount]
  )

  return <StripRepeatContext.Provider value={ctx}>{children}</StripRepeatContext.Provider>
}

const GridCtxComponent = ({
  elementClasses,
  columns,
  children,
  rows,
  gridTemplateRowsOrigin,
  gridTemplateColumns,
  areas,
  childAreas,
  component,
  styleRef,
  classes,
  gridAreaStyleRules,
  componentStyles,
}) => {
  const ctx = useMemo(() => {
    return {
      elementClasses,
      columns,
      rows,
      gridTemplateColumns,
      areas,
      childAreas,
      component,
      styleRef,
      classes,
      gridAreaStyleRules,
      componentStyles,
    }
  }, [
    elementClasses,
    columns,
    rows,
    gridTemplateColumns,
    areas,
    childAreas,
    component,
    styleRef,
    classes,
    gridAreaStyleRules,
    componentStyles,
  ])
  return <GridContext.Provider value={ctx}>{children}</GridContext.Provider>
}

export const RepeatCtx = React.memo(RepeatCtxComponent)
export const GridCtx = React.memo(GridCtxComponent)
